//* 公共组件
import type { SearchGeneModal } from "@/components/windows";
//* 工具函数
import { Formats } from "@/assets/js";

export const useComposable = () => {
    //* 插件
    const route = useRoute();

    //* 响应式变量
    const refs = {
        keyword: ref<string>(""),
        modal: ref<InstanceType<typeof SearchGeneModal>>(),
    };

    //* 函数列表
    const methods = {
        //* 基因窗口选择回调
        change: (data: any) => routerPush({ name: "DBSNP", query: { id: data?.id || "" } }),
        //* 搜索事件回调
        search: () => {
            refs.modal.value?.open(refs.keyword.value);
        },
    };

    //* 侦听器
    const watchs = {
        stop: watchEffect(() => {
            //* 数据初始化
            const id = Formats.query(route.query.id);
            //* 路由存在id时, 跳转到详情页中
            if (!id) return;
            else {
                routerPush({ name: "DBSNPResult", query: { id } }, { replace: true });
            }
        }),
    };

    return { refs, watchs, methods };
};
